<div class="container-fluid">
    <div class="pb-wrapper bg-white p-4">




        <div class="row">
            <div class="col-xl-12 col-lg-12">
                <div class="all-leads mt-5">
                    <div class="card shadow mb-4">
                        <div class="card-body">
                            <h3 class="d-inline-block mr-3 mb-0" style="color: rgb(177, 128, 128);">Billing</h3>
                            <div class="table-responsive">
                                <table class="table table-hover agent-table">
                                    <thead>
                                        <tr>
                                            <th>S.NO</th>
                                            <th>MM/YY</th>
                                            <th>Decors Bill (A)</th>
                                            <th>Packages Bill (B)</th>
                                            <th>Total Business (C)</th>
                                            <th>Franchise Share</th>
                                            <th>PB Share</th>
                                            <th>Settled On</th>
                                            <th>Approval</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of filteredMembers">
                                            <td><input type="checkbox"></td>
                                            <td>{{ item.MM_YY }}</td>
                                            <td>{{ item.DecorsBill_A }}</td>
                                            <td>{{ item.PackagesBill_B }}</td>
                                            <td>{{ item.TotalBusiness_C }}</td>
                                            <td>₹{{ item.FranchiseShare }}</td>
                                            <td>₹{{ item.PBShare }}</td>
                                            <td>{{ item.SettledOn }}</td>
                                            <td>{{ item.Approval }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>